<template>
  <div
    class="account-menu"
    @focusout="handleBlur">
    <button
      type="button"
      class="account-menu__trigger"
      :aria-expanded="expanded"
      aria-haspopup="true"
      @click="toggleExpanded">
      <span
        class="icon icon--captain account-menu__icon"
        aria-hidden="true" />
      {{ translations["bookings.header.myaccount"] }}
    </button>

    <ul
      v-if="expanded"
      class="account-menu__list">
      <li
        v-for="item in availableMenuItems"
        :key="item.routeName"
        class="account-menu__item">
        <a
          :href="item.href"
          class="account-menu__link"
          @click="expanded = false">
          {{ item.linkText }}
        </a>
      </li>
      <li class="account-menu__item">
        <button
          type="button"
          class="account-menu__link"
          @click="handleLogout">
          {{ translations["bookings.header.logout"] }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useAuth } from "@services/authentication";
import { getTranslations } from "@shared/Services/translations";
import { getBookingRouteUrl } from "@services/booking-route-service";

const props = withDefaults(defineProps<{
  menuItems?: MenuItem[];
}>(), {
  menuItems: () => [],
});

const { logout } = useAuth();
const translations = getTranslations();
const expanded = ref(false);

const availableMenuItems = computed(() =>
  props.menuItems.map((item) => ({
    ...item,
    href: getBookingRouteUrl(item.routeName),
  }))
);

function toggleExpanded(): void {
  expanded.value = !expanded.value;
}

function handleBlur(event: FocusEvent): void {
  const currentTarget = event.currentTarget;
  const relatedTarget = event.relatedTarget;

  if (!(currentTarget instanceof HTMLElement)) {
    expanded.value = false;
    return;
  }

  if (relatedTarget instanceof Node && currentTarget.contains(relatedTarget)) {
    return;
  }

  expanded.value = false;
}

function handleLogout(): void {
  expanded.value = false;
  logout();
}
</script>
